export default {
  defaultLocale: 'en-us',
  locales: ['en-us','fr'],
}
